export enum DialogType {
  OVERLAP_WARNING = 'OVERLAP_WARNING',
  RECURRENCE_WARNING = 'RECURRENCE_WARNING',
  SMART_ACTION_DIALOG = 'SMART_ACTION_DIALOG',
  ENTITY_AVAILABILITY_DIALOG = 'ENTITY_AVAILABILITY_DIALOG'
}
